import { render, staticRenderFns } from "./ReplyRegForm.vue?vue&type=template&id=764760ae&scoped=true&"
import script from "./ReplyRegForm.vue?vue&type=script&lang=js&"
export * from "./ReplyRegForm.vue?vue&type=script&lang=js&"
import style0 from "./ReplyRegForm.vue?vue&type=style&index=0&id=764760ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764760ae",
  null
  
)

export default component.exports